import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_CONFIG } from "config/config.jsx";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Card,
  Button,
  CardFooter,
  CardBody,
  FormGroup,
  Input,
  Container,
  Col,
  Form,
  FormFeedback,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { logout } from "../../../actions/auth";

class EmailForm extends Component {
  state = {
    email: "",
    emailState: "",
    loading: false,
  };

  verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };
  change = (event, stateName) => {
    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(event.target.value)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
    this.setState({ [stateName]: event.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (this.state.emailState === "has-success") {

    //   this.props.setIsLoading(true);
      try {
        await axios.post(`${API_CONFIG.HOST}/user/forgot-password`, {
          userMail: this.state.email,
        }).then((res) => {
            console.log(res,this.state.email)
            // this.props.setIsLoading(false);
            this.props.handleEmailSucces(this.state.email);
        });
      } catch (err) {
        console.log({ err });
      }
    } else if (
      this.state.emailState === "" 
    ) {
      this.setState({ emailState: "has-danger" });     
    }
  };

  render() {
    let { emailState } = this.state;
    return (
      <div>
        <Box
          mb={3}
          sx={{
            //   display: "flex",

            width: "100%",
            
            //   justifyContent: "center",
          }}
        >
          <Form onSubmit={this.handleSubmit}>
            {/* <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                rowGap: 3,
                mb: 2,
              }}
            > */}
              <FormGroup className={`has-label ${emailState}`}>
                <label>Email *</label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText style={{ border: "1px solid #E9ECEF" }}>
                      <i className="fas fa-envelope" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="off"
                    placeholder="enter email"
                    valid={emailState === "has-success"}
                    invalid={emailState === "has-danger"}
                    onChange={(e) => this.change(e, "email")}
                    style={{ border: "1px solid #ffffff" }}
                  />
                </InputGroup>
                <FormFeedback
                  valid={emailState === "has-success"}
                  invalid={emailState === "has-danger"}
                >
                  {this.state.emailState === "has-danger" ? (
                    "email is required."
                  ) : (
                    <span />
                  )}
                </FormFeedback>
              </FormGroup>

              {/* <FormGroup>
                     
                    </FormGroup> */}
            {/* </Box> */}
            <FormGroup>
            <Button
            fullwidth
            type="submit"
            block
            color="success"
            size="sm"
            onClick={this.handleSubmit}
            disabled={!(emailState === "has-success")}
          >
            send OTP
          </Button>
          </FormGroup>
          </Form>
         
        </Box>
      </div>
    );
  }
}

export default EmailForm;
